export default __webpack_public_path__ + "static/media/rosn-closed-stub.e7fd1d24.svg";